import React, { useMemo, useState } from 'react';
import { BadgeCheck, Search, ThumbsUp, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { REVIEWS, REVIEW_STATS, FLAVOUR_ORDER, FLAVOURS, LIFESTYLE } from '../data/mock';
import StarRating from '../components/StarRating';
import Reveal from '../components/Reveal';

export default function Reviews() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');
  const [q, setQ] = useState('');

  const filtered = useMemo(() => REVIEWS.filter((r) => (filter==='all'||r.flavour===filter) && (r.text.toLowerCase().includes(q.toLowerCase())||r.name.toLowerCase().includes(q.toLowerCase()))), [filter,q]);

  return (
    <div className="pt-24">
      <section className="relative py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0"><img src={LIFESTYLE.confidentDark} alt="" className="w-full h-full object-cover opacity-30" /><div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent" /></div>
        <div className="relative max-w-[1400px] mx-auto px-5">
          <Reveal>
            <p className="font-cond tracking-[0.3em] text-white/50 mb-3">REVIEWS</p>
            <h1 className="font-display text-5xl md:text-8xl">REAL PEOPLE.<br /><span className="text-flavour flavour-transition">REAL S-MAN.</span></h1>
            <div className="flex items-center gap-4 mt-6">
              <span className="font-display text-6xl">{REVIEW_STATS.rating}</span>
              <div><StarRating value={5} size={22} /><p className="text-sm text-white/50 mt-1">Based on {REVIEW_STATS.count.toLocaleString()} verified reviews</p></div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* filters */}
      <section className="py-8 border-y border-white/10 bg-[#0a0a0a] sticky top-[68px] z-30">
        <div className="max-w-[1400px] mx-auto px-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 flex-wrap">
            {['all', ...FLAVOUR_ORDER].map((id) => {
              const on = filter===id; const color = id==='all'?'#ff2d2d':FLAVOURS[id].primary;
              return (<button key={id} onClick={()=>setFilter(id)} className="px-4 py-2 rounded-full border font-cond tracking-wide text-sm transition-all" style={{ borderColor: on?color:'rgba(255,255,255,0.12)', background:on?color:'transparent', color:on?'#000':'rgba(255,255,255,0.7)' }}>{id==='all'?'ALL':FLAVOURS[id].name}</button>);
            })}
          </div>
          <div className="relative w-full md:w-64">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
            <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search reviews..." className="w-full bg-white/[0.04] border border-white/10 rounded-full pl-9 pr-4 py-2 text-sm outline-none focus:border-white/30" />
          </div>
        </div>
      </section>

      {/* grid */}
      <section className="py-14">
        <div className="max-w-[1400px] mx-auto px-5 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {filtered.map((r) => {
            const color = r.flavour==='mix'?'#ff2d2d':(FLAVOURS[r.flavour]?.primary||'#ff2d2d');
            return (
              <div key={r.id} className="break-inside-avoid mb-5 rounded-2xl border border-white/10 bg-[#0d0d0d] p-5">
                <StarRating value={r.rating} size={15} />
                <p className="text-white/80 mt-3 text-sm leading-relaxed">“{r.text}”</p>
                <div className="mt-4 flex items-center justify-between">
                  <div><p className="font-cond tracking-wide text-sm">{r.name}</p><p className="text-xs" style={{color}}>{r.flavour==='mix'?'Mix Box':FLAVOURS[r.flavour]?.name}</p></div>
                  {r.verified && <span className="flex items-center gap-1 text-[10px] text-white/40"><BadgeCheck className="w-3.5 h-3.5" style={{color}} /> Verified</span>}
                </div>
              </div>
            );
          })}
          {filtered.length===0 && <p className="text-white/40 text-center col-span-full">No reviews match your search.</p>}
        </div>
      </section>

      {/* fan clubs */}
      <section className="py-16 bg-[#080808]">
        <div className="max-w-[1400px] mx-auto px-5">
          <Reveal className="mb-10"><h2 className="font-display text-3xl md:text-5xl">SIX FLAVOURS.<br /><span className="text-flavour flavour-transition">SIX FAN CLUBS.</span></h2></Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {FLAVOUR_ORDER.map((id) => { const f=FLAVOURS[id]; return (
              <div key={id} className="rounded-2xl border border-white/10 p-5 text-center" style={{ background:`radial-gradient(circle at 50% 0%, rgba(${f.rgb},0.12), transparent 70%), #0b0b0b` }}>
                <img src={f.fruit} alt={f.name} loading="lazy" className="w-14 h-14 rounded-full object-cover border-2 mx-auto mb-3" style={{borderColor:f.primary}} />
                <p className="font-display text-2xl">{f.rating}<span className="text-white/30 text-lg">/5</span></p>
                <p className="font-cond text-sm" style={{color:f.primary}}>{f.name}</p>
                <p className="text-xs text-white/40 mt-1">{f.reviews} reviews</p>
              </div>
            ); })}
          </div>
        </div>
      </section>

      <section className="py-20 text-center">
        <button onClick={()=>navigate('/flavours')} className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#ff2d2d] text-white font-cond tracking-wide text-lg hover:brightness-110 transition-all">CHOOSE YOUR FLAVOUR <ArrowRight className="w-5 h-5" /></button>
      </section>
    </div>
  );
}
